import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// components
import { LoadingScreen } from 'src/commons/components/loading-screen';
// context
import { StepServicePaymentProvider } from 'src/features/service-payment/context/step-context';
import { FormProvider } from 'src/features/service-payment/context/form-provider';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/features/service-payment'));

// ----------------------------------------------------------------------

export const servicePaymentRoutes = [
  {
    path: '/service-payment',
    element: (
      <Suspense fallback={<LoadingScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        element: (
          <FormProvider>
            <StepServicePaymentProvider>
              <IndexPage />
            </StepServicePaymentProvider>
          </FormProvider>
        ),
        index: true,
      },
    ],
  },
];
